<li data-id="{{item.id}}" class="list-item btn" {{allowedTitle item "name"}}>
    <div class="icon-m icon-left {{item.getKindIcon()}}">
        <h3>{{item.name}}</h3>
        <p>{{item.getKindLabel()}}</p>
    </div>
</li>
